import { api } from "./client";

export const repoApi = {
  // engagement_id is required by the backend — a repo is scoped to one
  // engagement, not the whole org (see ListReposQuery).
  list: (engagementId, includeInactive = false) =>
    api.get(`/codebase/repos`, {
      params: { engagement_id: engagementId, include_inactive: includeInactive },
    }),

  get: (repoId) => api.get(`/codebase/repos/${repoId}`),

  create: (payload) => api.post(`/codebase/repos`, payload),

  update: (repoId, payload) => api.put(`/codebase/repos/${repoId}`, payload),

  deactivate: (repoId) => api.delete(`/codebase/repos/${repoId}`),

  testConnection: (repoId) => api.post(`/codebase/repos/${repoId}/test-connection`),
};
